import React from 'react';
import { DataGrid, GridColDef, GridActionsCellItem } from '@mui/x-data-grid';
import { Chip } from '@mui/material';
import { OrganizationNotificationTrigger } from '../../../services/Hub/notificationCenter/types';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

interface TriggersTableProps {
  triggers: OrganizationNotificationTrigger[];
  pagination: {
    total: number;
    currentPage: number;
    itemsPerPage: number;
  };
  isLoading: boolean;
  onEditTrigger: (trigger: OrganizationNotificationTrigger) => void;
  onDeleteTrigger: (triggerId: string) => void;
  onPageChange: (page: number, itemsPerPage: number) => void;
}

export default function TriggersTable({
  triggers,
  pagination,
  isLoading,
  onEditTrigger,
  onDeleteTrigger,
  onPageChange
}: TriggersTableProps) {
  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: 'Nome',
      flex: 1,
      minWidth: 200
    },
    {
      field: 'source',
      headerName: 'Fonte',
      flex: 1,
      minWidth: 150,
      renderCell: params => <Chip label={params.value} size="small" variant="outlined" />
    },
    {
      field: 'isActive',
      headerName: 'Status',
      width: 120,
      renderCell: params => (
        <Chip
          label={params.value ? 'Ativo' : 'Inativo'}
          color={params.value ? 'success' : 'default'}
          size="small"
        />
      )
    },
    {
      field: 'createdAt',
      headerName: 'Criado em',
      width: 180,
      renderCell: params => (
        <div>
          {new Date(params.value).toLocaleDateString('pt-BR')}{' '}
          {new Date(params.value).toLocaleTimeString('pt-BR', {
            hour: '2-digit',
            minute: '2-digit'
          })}
        </div>
      )
    },
    {
      field: 'actions',
      headerName: 'Ações',
      type: 'actions',
      width: 120,
      getActions: params => [
        <GridActionsCellItem
          icon={<EditIcon />}
          label="Editar"
          color="primary"
          onClick={() => onEditTrigger(params.row)}
        />,
        <GridActionsCellItem
          icon={<DeleteIcon sx={{ color: 'error.main' }} />}
          label="Excluir"
          onClick={() => onDeleteTrigger(params.row.id)}
        />
      ]
    }
  ];

  return (
    <DataGrid
      rows={triggers}
      columns={columns}
      pagination
      paginationMode="server"
      rowCount={pagination.total}
      paginationModel={{
        page: pagination.currentPage - 1,
        pageSize: pagination.itemsPerPage
      }}
      pageSizeOptions={[5, 10, 20]}
      onPaginationModelChange={model => {
        onPageChange(model.page + 1, model.pageSize);
      }}
      loading={isLoading}
      disableRowSelectionOnClick
      autoHeight
    />
  );
}
